import './Ticket.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import {Badge} from "react-bootstrap";
import {useNavigate, useInRouterContext} from "react-router-dom";

const TicketComponent = ({ticket, onClick, showArea = false, showButtonMushroom = true}) => {
    // const inRouter = useInRouterContext();
    // const navigate =  useNavigate() ;

    function handleClick(advantages = false) {
        if (typeof onClick === "function")
            onClick(advantages);
        // } else if(inRouter) {
        //     navigate("/buy/" + ticket.id + (advantages ? "?advantage=true" : ""))
        // }
    }

    let area = ticket.area;
    let second_btn = null;
    if(showButtonMushroom) {
        if (area.category.type === "TYPE_MUSHROOM")
            second_btn = <Button variant="light" onClick={() => handleClick(true)}>Usa con la
                tabella intelligente</Button>
    }
    let header = [];
    if(showArea){
        let image = ticket.image;
        if (image === null)
            image = ticket.area.image;
        image = global.baseUrl + encodeURI(image);

        header.push(<div className="ticket-image"
            style={{backgroundImage: `url(${image})`}}
        >
            <span>{area.name}</span>
        </div>)
    }

    return (
        <div className="ticket-container">
            {header}
            <div className={`ticket-body`}>
                <span><b>{ticket.name}</b></span>
                <b className={"orange"}>{global.getNameTicketType(ticket.type)}</b>
                <span>Categoria {ticket.ticket_residence_type.name}</span>

                <span>{ticket.date_start_validity} - {ticket.date_end_validity}</span>
                <div style={{display: "absolute", top: 0}}>
                    <Badge bg="success" className={"price"}>{ticket.price.toFixed(2)}€</Badge>
                </div>
                <Badge bg="dark">Area {ticket.area.name}</Badge>
                <Badge bg="dark" className={"mt-1"}>Tipologia {ticket.ticket_residence_type.name}</Badge>
            </div>
            <div className="ticket-footer">
                <Button variant="success" onClick={() => handleClick()}>Acquista ticket</Button>
                {second_btn}
            </div>
        </div>
    );
};

export default TicketComponent;
